import axios from "axios";
import { api } from "./api_route";

export const resizePDF = async (file, targetSize) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (targetSize !== undefined) {
      formData.append("targetSize", targetSize);
    }
    const response = await axios.post(`${api}/helper/resize-pdf`, formData, {
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("resizePDF API call failed:", error);
    throw error;
  }
};
export const getConnectionInfo = async () => {
  try {
    const response = await axios.get(`${api}/helper/connection-info`);
    return response.data;
  } catch (error) {
    console.error("getConnectionInfo failed:", error);
    throw error;
  }
};

export const pingServer = async () => {
  const t0 = performance.now();
  await axios.get(`${api}/helper/ping`, {
    headers: { 'Cache-Control': 'no-store, no-cache' }
  });
  return performance.now() - t0;
};

export const downloadTest = async (bytes = 10000000, signal) => {
  const t0 = performance.now();
  const response = await axios.get(`${api}/helper/download-test?bytes=${bytes}`, {
    responseType: 'arraybuffer',
    headers: { 'Cache-Control': 'no-store, no-cache' },
    signal,
    timeout: 60000
  });
  const elapsed = (performance.now() - t0) / 1000;
  return (response.data.byteLength * 8) / elapsed / 1_000_000; // Mbps
};

export const uploadTest = async (blob, signal) => {
  const t0 = performance.now();
  await axios.post(`${api}/helper/upload-test`, blob, {
    headers: { 'Cache-Control': 'no-store, no-cache' },
    signal,
    timeout: 60000
  });
  const elapsed = (performance.now() - t0) / 1000;
  return (blob.size * 8) / elapsed / 1_000_000; // Mbps
};
